export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_07.5cf8d2db.png";